import { Component, inject } from '@angular/core';
import { Link } from '@core/models/atomics.model';
import { LinkComponent } from '@shared/components/link/link.component';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';

@Component({
  selector: 'cx-footer-navigation-bar',
  templateUrl: './cx-footer-navigation-bar.component.html',
  styleUrls: ['./cx-footer-navigation-bar.component.scss'],
  imports: [LinkComponent],
})
export class CxFooterNavigationBarComponent {
  protected data = inject<{ items: Link[] }>(CX_ABSTRACT_COMPONENT_DATA);
}
